// Live activity notification configuration.
// "sample" = demo data for preview/testing. "real" = only genuine anonymized enquiries.
export const ACTIVITY_MODE = "sample";

// If true, sample names are anonymized further: "Rahul" -> "R***"
export const ANONYMIZE_NAMES = false;

export const TIMING = {
  firstDelayMinMs: 10000,
  firstDelayMaxMs: 15000,
  intervalMinMs: 20000,
  intervalMaxMs: 35000,
  visibleMinMs: 5000,
  visibleMaxMs: 7000,
};

export const ACTIVITY_DISMISS_KEY = "sg_activity_dismissed";
export const REAL_ACTIVITY_KEY = "sg_real_activity";
